"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EventDetailInfo = exports.DescritionViewer = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _i18next = _interopRequireDefault(require("i18next"));
var _reactShadow = _interopRequireDefault(require("react-shadow"));
var _reactI18next = require("react-i18next");
var _autolinker = _interopRequireDefault(require("../../utils/autolinker"));
var _excluded = ["summary"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FIELD_TEXT = {
  when: _i18next["default"].t('calendar.event.when'),
  attendee: _i18next["default"].t('calendar.event.who'),
  location: _i18next["default"].t('calendar.event.where'),
  repeat: _i18next["default"].t('calendar.event.repeat'),
  description: _i18next["default"].t('calendar.event.description'),
  viewInCalendar: '',
  addToCalendar: ''
};
var RSVP_STATUS = {
  yes: _i18next["default"].t('calendar.event.rsvp.response.yes'),
  no: _i18next["default"].t('calendar.event.rsvp.response.no'),
  maybe: _i18next["default"].t('calendar.event.rsvp.response.maybe')
};
var rsvpText = _i18next["default"].t('calendar.event.rsvp');
var organizerText = _i18next["default"].t('calendar.event.attendee.organizer');
var andText = _i18next["default"].t('calendar.event.attendee.and');
var showInCalendarText = _i18next["default"].t('calendar.event.preview.showInCalendar');
var addToCalendarText = _i18next["default"].t('calendar.event.preview.addToCalendar');
var detectDescriptionHTML = function detectDescriptionHTML(description) {
  //https://yipitdata5.atlassian.net/browse/EWM-3557
  if (description.match('<https?://[^>]+>')) {
    return false;
  }
  return true;
};
var DescritionViewer = exports.DescritionViewer = function DescritionViewer(_ref) {
  var description = _ref.description;
  var rootRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    (0, _autolinker["default"])(rootRef.current);
  }, [description]);
  if (!detectDescriptionHTML(description)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: rootRef
    }, description);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: rootRef,
    dangerouslySetInnerHTML: {
      __html: description
    }
  });
};
var DescriptionField = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var description = _ref2.description;
  if (!description) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row items-start justify-start text-base py-3 w-full overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0 font-light text-light pr-3 w-24"
  }, FIELD_TEXT['description']), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      wordWrap: 'anywhere'
    },
    className: "break-word text-overflow whitespace-pre-line"
  }, /*#__PURE__*/_react["default"].createElement(_reactShadow["default"].div, null, /*#__PURE__*/_react["default"].createElement(DescritionViewer, {
    description: description
  }))));
});
var SimpleField = /*#__PURE__*/_react["default"].memo(function (_ref3) {
  var displayName = _ref3.displayName,
    value = _ref3.value;
  if (!value) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row items-start justify-start text-base py-3 w-full overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0 font-light text-light pr-3 w-24"
  }, FIELD_TEXT[displayName]), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      wordWrap: 'anywhere'
    },
    className: "break-word text-overflow"
  }, value));
});
var ActionLink = /*#__PURE__*/_react["default"].memo(function (_ref4) {
  var type = _ref4.type,
    callback = _ref4.callback;
  var debouncedOnClick = (0, _react.useMemo)(function () {
    if (!callback) {
      return null;
    }
    return (0, _debounce["default"])(function () {
      callback();
    }, 500, {
      leading: true,
      trailing: false
    });
  }, [callback]);
  (0, _react.useEffect)(function () {
    return function () {
      if (debouncedOnClick) {
        debouncedOnClick.cancel();
      }
    };
  }, []);
  if (!callback) {
    return null;
  }
  var displayText = '';
  if (type === 'showInCalendar') {
    displayText = showInCalendarText;
  } else if (type === 'addToCalendar') {
    displayText = addToCalendarText;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row items-start justify-start text-base py-4 px-6 w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pr-3 w-24"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      cursor: 'pointer'
    },
    className: "text-primary pointer font-bold",
    onClick: debouncedOnClick
  }, displayText));
});
var RSVPAction = /*#__PURE__*/_react["default"].memo(function (_ref5) {
  var rsvpText = _ref5.rsvpText,
    selected = _ref5.selected,
    onChange = _ref5.onChange;
  var selectedColor = '';
  if (selected) {
    selectedColor = 'text-primary bg-secondary font-bold';
  }
  var callback = (0, _react.useMemo)(function () {
    if (!onChange) {
      return undefined;
    }
    return function () {
      onChange(rsvpText);
    };
  }, [rsvpText, onChange]);
  var width = rsvpText === 'maybe' ? 'w-20' : 'w-14';
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      cursor: !onChange ? 'default' : 'pointer'
    },
    className: "text-center ".concat(selectedColor, " py-2 px-3 rounded ").concat(width, " hover:bg-secondary ml-2"),
    onClick: callback
  }, RSVP_STATUS[rsvpText]);
});
var RSVPActions = /*#__PURE__*/_react["default"].memo(function (_ref6) {
  var rsvpStatus = _ref6.rsvpStatus,
    onRSVPStatusChange = _ref6.onRSVPStatusChange,
    disabled = _ref6.disabled,
    hide = _ref6.hide;
  var mountRef = (0, _react.useRef)(true);
  var _useState = (0, _react.useState)(typeof rsvpStatus === 'string' ? rsvpStatus.toLocaleLowerCase() : ''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    rsvp = _useState2[0],
    setRsvp = _useState2[1];
  var onThrottledRSVPChange = (0, _react.useMemo)(function () {
    if (!onRSVPStatusChange) {
      return null;
    }
    return (0, _debounce["default"])(function (status) {
      if (onRSVPStatusChange && !disabled) {
        onRSVPStatusChange(status)["catch"](function (e) {
          if (mountRef.current) {
            setRsvp(rsvpStatus);
          }
        });
      }
    }, 1500, {
      leading: false,
      trailing: true
    });
  }, [onRSVPStatusChange, rsvpStatus, disabled]);
  var onChange = (0, _react.useMemo)(function () {
    if (!onThrottledRSVPChange) {
      return null;
    }
    return function (status) {
      setRsvp(status);
      onThrottledRSVPChange(status);
    };
  }, [onThrottledRSVPChange]);
  (0, _react.useEffect)(function () {
    return function () {
      mountRef.current = false;
      if (onThrottledRSVPChange) {
        onThrottledRSVPChange.flush();
      }
    };
  }, []);
  if (disabled || hide) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-row items-center justify-start text-base py-3 w-full overflow-hidden select-none"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0 font-light text-light pr-3 w-24"
  }, rsvpText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-normal text-light flex flex-row items-start justify-between"
  }, /*#__PURE__*/_react["default"].createElement(RSVPAction, {
    key: 'yes',
    rsvpText: 'yes',
    selected: rsvp === 'yes',
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement(RSVPAction, {
    key: 'no',
    rsvpText: 'no',
    selected: rsvp === 'no',
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement(RSVPAction, {
    key: 'maybe',
    rsvpText: 'maybe',
    selected: rsvp === 'maybe',
    onChange: onChange
  })));
});
var Attendees = /*#__PURE__*/_react["default"].memo(function (_ref7) {
  var attendees = _ref7.attendees;
  var organizer = '';
  var middleTexts = [];
  var lastText = '';
  attendees.forEach(function (attendee, index) {
    if (attendee.isOrganizer) {
      organizer = "".concat(attendee.name || attendee.email, " (").concat(organizerText, ")");
    } else if (index !== attendees.length - 1 || index === 0) {
      middleTexts.push("".concat(attendee.name || attendee.email));
    } else if (index === attendees.length - 1 && index !== 0) {
      if (attendees.length === 2) {
        lastText = "".concat(attendee.name || attendee.email);
      } else {
        lastText = "".concat(andText, " ").concat(attendee.name || attendee.email);
      }
    }
  });
  var ret = [];
  if (organizer) {
    ret.push(organizer);
  }
  ret.push.apply(ret, middleTexts);
  if (lastText) {
    ret.push(lastText);
  }
  var attendeesText = ret.join(', ');
  return /*#__PURE__*/_react["default"].createElement(SimpleField, {
    displayName: 'attendee',
    value: attendeesText
  });
});
var EventDifferent = /*#__PURE__*/_react["default"].memo(function (_ref8) {
  var isUpdated = _ref8.isUpdated,
    cancelled = _ref8.cancelled,
    isSoftDelete = _ref8.isSoftDelete;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  if (isSoftDelete) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt-3 text-xs text-red font-bold"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "py-1 px-2 bg-error rounded"
    }, t('calendar.event.preview.eventSoftDeleted')));
  }
  if (cancelled) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt-3 text-xs text-red font-bold"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "py-1 px-2 bg-error rounded"
    }, t('calendar.event.preview.eventCancelled')));
  }
  if (isUpdated) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt-3 text-xs font-bold"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "py-1 px-2 bg-secondary rounded"
    }, t('calendar.event.preview.eventUpdated')));
  }
  return null;
});
var EventDetailInfo = exports.EventDetailInfo = /*#__PURE__*/_react["default"].memo(function (_ref9) {
  var hideRSVPStatus = _ref9.hideRSVPStatus,
    rsvpStatus = _ref9.rsvpStatus,
    onRSVPChange = _ref9.onRSVPChange,
    description = _ref9.description,
    when = _ref9.when,
    repeat = _ref9.repeat,
    location = _ref9.location,
    attendees = _ref9.attendees,
    isUpdated = _ref9.isUpdated,
    cancelled = _ref9.cancelled,
    isSoftDelete = _ref9.isSoftDelete,
    onAddToCalendar = _ref9.onAddToCalendar,
    onViewInCalendar = _ref9.onViewInCalendar;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-6 pt-4 max-h-80vh lg:max-h-500px overflow-y-auto w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col text-dark space-around items-baseline items-left max-w-50vw lg:max-w-30vw "
  }, /*#__PURE__*/_react["default"].createElement(EventDifferent, {
    isSoftDelete: isSoftDelete,
    cancelled: cancelled,
    isUpdated: isUpdated
  }), /*#__PURE__*/_react["default"].createElement(RSVPActions, {
    key: rsvpStatus,
    hide: hideRSVPStatus,
    disabled: cancelled,
    rsvpStatus: rsvpStatus,
    onRSVPStatusChange: onRSVPChange
  }), /*#__PURE__*/_react["default"].createElement(SimpleField, {
    displayName: 'when',
    value: when
  }), /*#__PURE__*/_react["default"].createElement(SimpleField, {
    displayName: 'repeat',
    value: repeat
  }), /*#__PURE__*/_react["default"].createElement(SimpleField, {
    displayName: 'location',
    value: location
  }), /*#__PURE__*/_react["default"].createElement(Attendees, {
    attendees: attendees
  }), /*#__PURE__*/_react["default"].createElement(DescriptionField, {
    description: description
  }))), /*#__PURE__*/_react["default"].createElement(ActionLink, {
    key: "addToCalendar",
    type: "addToCalendar",
    callback: onAddToCalendar
  }), /*#__PURE__*/_react["default"].createElement(ActionLink, {
    key: "showInCalendar",
    type: "showInCalendar",
    callback: onViewInCalendar
  }));
});
var EventInfo = /*#__PURE__*/_react["default"].memo(function (data) {
  var summary = data.summary,
    others = (0, _objectWithoutProperties2["default"])(data, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "shadow-lg rounded dark:bg-card flex flex-col text-dark space-around items-baseline items-left "
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-2xl pt-4 pb-2 px-6 w-full truncate"
  }, summary.replace(/\\n/g, '')), /*#__PURE__*/_react["default"].createElement(EventDetailInfo, others));
});
var _default = exports["default"] = EventInfo;
//# sourceMappingURL=EventInfo.js.map